import type { ComponentProps } from 'react'

import { ICON_DEFAULT_COLOR, ICON_DEFAULT_FILL, type IconProps } from 'components'

export const FileChartColumn = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = '24', // TODO: Replace with ICON_DEFAULT_WIDTH when migration to ION is complete
  height = '24', // TODO: Replace with ICON_DEFAULT_HEIGHT when migration to ION is complete
  viewBox = '0 0 24 24', // TODO: Replace with ICON_DEFAULT_VIEWBOX when migration to ION is complete
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.25 20V4C3.25 3.27065 3.53994 2.57139 4.05566 2.05566C4.57139 1.53994 5.27065 1.25 6 1.25H15C15.1989 1.25 15.3896 1.32907 15.5303 1.46973L20.5303 6.46973C20.6709 6.61038 20.75 6.80109 20.75 7V20C20.75 20.7293 20.4601 21.4286 19.9443 21.9443C19.4286 22.4601 18.7293 22.75 18 22.75H6C5.27065 22.75 4.57139 22.4601 4.05566 21.9443C3.53994 21.4286 3.25 20.7293 3.25 20ZM7.25 18V17C7.25 16.5858 7.58579 16.25 8 16.25C8.41421 16.25 8.75 16.5858 8.75 17V18C8.75 18.4142 8.41421 18.75 8 18.75C7.58579 18.75 7.25 18.4142 7.25 18ZM11.25 18V12C11.25 11.5858 11.5858 11.25 12 11.25C12.4142 11.25 12.75 11.5858 12.75 12V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18ZM15.25 18V15C15.25 14.5858 15.5858 14.25 16 14.25C16.4142 14.25 16.75 14.5858 16.75 15V18C16.75 18.4142 16.4142 18.75 16 18.75C15.5858 18.75 15.25 18.4142 15.25 18ZM14.75 6C14.75 6.33152 14.8818 6.64937 15.1162 6.88379C15.3506 7.11821 15.6685 7.25 16 7.25H19.1895L14.75 2.81055V6ZM4.75 20C4.75 20.3315 4.88179 20.6494 5.11621 20.8838C5.35063 21.1182 5.66848 21.25 6 21.25H18C18.3315 21.25 18.6494 21.1182 18.8838 20.8838C19.1182 20.6494 19.25 20.3315 19.25 20V8.75H16C15.2707 8.75 14.5714 8.46006 14.0557 7.94434C13.5399 7.42861 13.25 6.72935 13.25 6V2.75H6C5.66848 2.75 5.35063 2.88179 5.11621 3.11621C4.88179 3.35063 4.75 3.66848 4.75 4V20Z"
        fill={color}
      />
    </svg>
  )
}
